import { FormControl, FormGroup, FormHelperText, InputLabel } from "@material-ui/core";
import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { Measure } from "utils/api";
import { IdMap } from "shared-types";
import styles from "./MeasuresListView.module.scss";
import MeasureItem from "./MeasureItem";

interface Props {
  allMeasures: IdMap<Measure>;
  protocolMeasureIds: string[];
  orderChange?(newOrder: string[]): void;
  handleChange?(event: ChangeEvent<HTMLInputElement>): void;
  error?: string;
}

const MeasuresListView: FC<Props> = ({ allMeasures, protocolMeasureIds, handleChange, error }) => {
  const [orderedMeasureIds, setOrderedMeasures] = useState<string[]>([]);

  useEffect(() => {
    setOrderedMeasures([...protocolMeasureIds]);
  }, [protocolMeasureIds]);

  const remainingMeasureIds = Array.from(allMeasures.values())
    .filter((m) => !orderedMeasureIds.includes(m.id))
    .map((m) => m.id);

  const allOrderedMeasures = [...orderedMeasureIds, ...remainingMeasureIds]
    .map((id) => {
      return allMeasures.get(id);
    })
    .filter((m): m is Measure => m !== undefined);

  return (
    <div data-testid="measures-list">
      <InputLabel className={styles.measuresLabel}>Measures</InputLabel>
      <FormControl component="fieldset" fullWidth error={Boolean(error)}>
        <FormGroup>
          {allOrderedMeasures.map((measure) => (
            <MeasureItem
              key={measure.id}
              measure={measure}
              isChecked={orderedMeasureIds.includes(measure.id)}
              handleChange={handleChange}
            />
          ))}
        </FormGroup>
        <FormHelperText error={Boolean(error)}>{error}</FormHelperText>
      </FormControl>
    </div>
  );
};

export default MeasuresListView;
